const timelineData = [
    {
        button: 'Today',
    },
    {
        time: '1 hour ago',
        description: 'Dolorum provident rerum aut hic quasi placeat iure tempora laudantium ipsa ad debitis unde?',
        align: 'left',
        minute: '08:25 am'
    },
    {
        time: '2 hours ago',
        // tslint:disable-next-line: max-line-length
        description: 'consectetur adipisicing elit. Iusto, optio, dolorum John deon provident rerum aut hic quasi placeat iure tempora laudantium ',
        minute: '08:25 am'
    },
    {
        time: '10 hours ago',
        description: '3 new photo Uploaded on facebook fan page',
        align: 'left',
        image: ['assets/images/small/img-1.jpg', 'assets/images/small/img-2.jpg', 'assets/images/small/img-3.jpg'],
        minute: '08:25 am'
    },
    {
        time: '14 hours ago',
        description: 'Outdoor visit at California State Route 85 with John Boltana & Harry Piterson regarding to setup a new show room.',
        minute: '08:25 am'
    },
    {
        time: '19 hours ago',
        description: 'Jonatha Smith added new milestone Pathek Lorem ipsum dolor sit amet consiquest dio',
        align: 'left',
        minute: '08:25 am'
    },
    {
        button: 'Yesterday',
    },
    {
        time: '22 February 2019',
        description: 'Montly Regular Medical check up at Greenland Hospital by the doctor Johm meon',
        minute: '08:25 am'
    },
    {
        time: '07 January 2019',
        description: 'Download the new updates of Ubold admin dashboard',
        align: 'left',
        minute: '08:25 am'
    },
    {
        time: '02 January 2019',
        description: 'Jonatha Smith added new milestone crishtian Lorem ipsum dolor sit amet consiquest dio',
        minute: '08:25 am'
    },
    {
        button: 'Last Month',
    },
    {
        time: '31 December 2018',
        description: 'Download the new updates of Ubold admin dashboard',
        minute: '08:25 am',
        align: 'left',
    },
    {
        time: '16 Decembar 2018',
        description: 'Jonatha Smith added new milestone prank Lorem ipsum dolor sit amet consiquest dio',
        minute: '08:25 am'
    }
];

export { timelineData };
